module.exports = __webpack_public_path__ + "img/w3_circle_trash_white.6af202a2.png";